(function () {
  /* Set this to the deployed tracking-worker URL to enable real view counting
     (see /worker/README.md). Left blank, tracking is a no-op and videos keep
     their existing (metaobject) order. */
  var TRACK_ENDPOINT = 'https://sportshero-video-view-tracker.niek-6f4.workers.dev';
  window.shCommunityTrackUrl = TRACK_ENDPOINT;

  var PLAY_VIDEO_LABEL = (window.SH_I18N && window.SH_I18N.community_slider_play_video_label) || 'Video afspelen';
  var DOT_LABEL_TEMPLATE = (window.SH_I18N && window.SH_I18N.community_slider_dot_label) || 'Ga naar video {n}';

  // Smoothing weight for both formulas below: with M = 50, a video needs
  // roughly 50 impressions before its own numbers outweigh the site-wide
  // average. Below that it sits near the middle of the pack -- the honest
  // place for a video nobody has seen yet, rather than a false #1 (four
  // impressions, one completion) or false last (four impressions, zero).
  var SMOOTHING_M = 50;

  // Phase 3 (dormant): a video only ranks by conversion once it has real
  // order signal. Below this gate, completion rate decides -- which is
  // every video today, and will be for a long time. Revisit this gate (and
  // the ranking formula generally) only after Phase 2 attribution has run
  // for a full quarter, per the build spec -- changing it more often than
  // the data refreshes is just noise-chasing.
  var QUALIFY_IMPRESSIONS = 200;
  var QUALIFY_ORDERS = 5;

  // Below this many impressions, completion rate is noise: with today's real
  // numbers (9-41 impressions, 0-2 completions per video), the smoothed
  // formula reduces to roughly 2.8/(impressions+50) for every zero-completion
  // video -- which ranks them WORSE than a video with zero data at all, i.e.
  // least-seen-first. That's a real ranking-quality bug, not just noise.
  // Below the gate, keep the exact key the initial render already sorted by
  // (view count), so nothing reorders while every video sits below it --
  // which also means nothing touches this already-visible scroll-snap
  // container, avoiding a separate scroll-position bug entirely rather than
  // racing to correct it after the fact. Ranking switches itself on per
  // video, automatically, once real impression data exists.
  var IMPRESSION_GATE = 50;

  function buildCard(v) {
    var card = document.createElement('div');
    card.className = 'sh-u';
    if (v.id) card.setAttribute('data-track-id', v.id);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sh-ugc-play-trigger';
    btn.setAttribute('data-sh-video-trigger', '');
    btn.setAttribute('aria-label', PLAY_VIDEO_LABEL);

    if (v.poster) {
      var img = document.createElement('img');
      img.src = v.poster;
      img.loading = 'lazy';
      img.alt = '';
      img.className = 'sh-vposter';
      btn.appendChild(img);
    }
    if (v.duration) {
      var dur = document.createElement('span');
      dur.className = 'sh-vdur';
      dur.textContent = v.duration;
      btn.appendChild(dur);
    }
    var play = document.createElement('span');
    play.className = 'sh-ugc-play';
    play.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
    btn.appendChild(play);
    card.appendChild(btn);

    var tpl = document.createElement('template');
    tpl.setAttribute('data-sh-video-src', '');
    tpl.innerHTML = '<video class="sh-vid-el" autoplay playsinline preload="none"><source src="' + v.src + '" type="video/mp4"></video>';
    card.appendChild(tpl);

    return card;
  }

  function setupArrows(wrap, track) {
    var prev = wrap.querySelector('[data-sh-ugc-prev]');
    var next = wrap.querySelector('[data-sh-ugc-next]');
    if (!prev || !next) return;

    function cardStep() {
      var card = track.querySelector('.sh-u');
      var w = card ? card.getBoundingClientRect().width : 200;
      return (w + 14) * 2;
    }
    function update() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      prev.style.display = (!scrollable || atStart) ? 'none' : 'flex';
      next.style.display = (!scrollable || atEnd) ? 'none' : 'flex';
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 300);
  }

  function setupDots(wrap, track) {
    var dotsWrap = wrap.querySelector('[data-sh-ugc-dots]');
    if (!dotsWrap) return;

    function build() {
      var cards = Array.prototype.slice.call(track.children);
      dotsWrap.innerHTML = '';
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      dotsWrap.hidden = !scrollable || !cards.length;
      if (!scrollable) return;
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sh-hslider-dot';
        dot.setAttribute('aria-label', DOT_LABEL_TEMPLATE.replace('{n}', i + 1));
        dot.addEventListener('click', function () {
          card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });
      updateActive();
    }

    function updateActive() {
      var cards = Array.prototype.slice.call(track.children);
      var dots = Array.prototype.slice.call(dotsWrap.children);
      if (!cards.length || !dots.length) return;
      var trackRect = track.getBoundingClientRect();
      var closest = 0, closestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackRect.left);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('sh-on', i === closest); });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActive, 80);
    }, { passive: true });
    window.addEventListener('resize', build);

    setTimeout(build, 300);
  }

  var trackEntries = [];

  document.querySelectorAll('[data-sh-ugc-track]').forEach(function (track) {
    var jsonId = track.getAttribute('data-videos-json');
    var script = jsonId ? document.querySelector('script[data-sh-community-json="' + jsonId + '"]') : null;
    if (!script) return;

    var videos;
    try {
      videos = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var wrap = track.closest('.sh-pdp-ugc-slider-wrap');
    var maxAttr = wrap ? wrap.getAttribute('data-max-videos') : null;
    var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    if (!max || isNaN(max)) max = Infinity;
    var productFilter = wrap ? wrap.getAttribute('data-product-filter') : null;
    var requireProductFlag = wrap ? wrap.getAttribute('data-require-product-flag') === 'true' : false;
    var locale = wrap ? (wrap.getAttribute('data-locale') || '').toLowerCase() : '';
    var currentLang = locale.split('-')[0];

    var list = videos;
    if (requireProductFlag) {
      list = list.filter(function (v) {
        return v.showOnProduct === true;
      });
    }
    if (productFilter) {
      list = list.filter(function (v) {
        return v.products && v.products.indexOf(productFilter) !== -1;
      });
    }
    list = list.filter(function (v) {
      if (!v.lang || v.lang.length === 0) return true;
      return v.lang.indexOf(currentLang) !== -1;
    });

    // Render immediately using the metaobject's own viewCount (usually 0) as
    // a tiebreaker, so the slider never waits on a network round trip to
    // the tracking worker before showing anything.
    list = list.slice().sort(function (a, b) {
      return (b.viewCount || 0) - (a.viewCount || 0);
    });
    list = list.slice(0, max).filter(function (v) { return v && v.src; });

    // Populating an already-visible scroll-snap container -- even for the
    // first time, into what starts as an empty track -- can trigger the same
    // browser scroll-follow behavior a later reorder does. Detaching first
    // makes it structurally impossible rather than racing to correct it
    // after: a node with no parent has no scrollport, so there's nothing for
    // the browser to scroll. Capture the reinsertion point before detaching,
    // since `wrap` (computed above via track.closest()) still needs `track`
    // attached to resolve, but building the cards does not.
    var parent = track.parentNode;
    var nextSibling = track.nextSibling;
    parent.removeChild(track);

    var entries = list.map(function (v) {
      var el = buildCard(v);
      track.appendChild(el);
      if (v.id && window.SHVideoEvents) {
        window.SHVideoEvents.observeImpression(el, v.id);
      }
      return { v: v, el: el };
    });
    track.scrollLeft = 0;

    if (nextSibling) {
      parent.insertBefore(track, nextSibling);
    } else {
      parent.appendChild(track);
    }

    trackEntries.push({ track: track, entries: entries });

    if (wrap) {
      setupArrows(wrap, track);
      setupDots(wrap, track);
    }
  });

  // Fetch real stats in the background and, if they change the order,
  // silently re-sort the already-rendered cards (no re-fetching, no re-paint
  // flash — just reordering existing DOM nodes).
  //
  // Ranking: completions per impression, smoothed toward the site-wide
  // average (SMOOTHING_M) so a video with a handful of impressions can't
  // swing to the top or bottom of the list. Once a video clears the
  // Phase 3 qualifying gate (real order attribution, not just plays), it
  // switches to ranking by orders per impression instead -- dormant until
  // there's enough data for that switch to mean anything.
  if (TRACK_ENDPOINT && trackEntries.length) {
    fetch(TRACK_ENDPOINT + '/stats')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (stats) {
        if (!stats) return;

        var totalImpressions = 0, totalCompletions = 0, totalOrders = 0;
        Object.keys(stats).forEach(function (id) {
          var s = stats[id];
          totalImpressions += s.impressions || 0;
          totalCompletions += s.completions || 0;
          totalOrders += s.orders || 0;
        });
        var siteCompletionRate = totalImpressions > 0 ? (totalCompletions / totalImpressions) : 0;
        var siteConversionRate = totalImpressions > 0 ? (totalOrders / totalImpressions) : 0;

        // Smoothed completion (or Phase-3 order) rate is a 0-1 value; raw
        // view count is not -- sorting the two groups together in one
        // comparator means whichever scale happens to be numerically larger
        // wins the sort regardless of merit, not a real ranking decision.
        // Split into two groups, each ranked by its own meaningful key, and
        // concatenate qualified-first, so the boundary is a deliberate
        // choice instead of an artefact of mismatched units.
        function rateScore(entry) {
          var s = stats[entry.v.id];
          var impressions = s.impressions || 0;
          var qualifiesForOrders = impressions >= QUALIFY_IMPRESSIONS && (s.orders || 0) >= QUALIFY_ORDERS;
          if (qualifiesForOrders) {
            return ((s.orders || 0) + SMOOTHING_M * siteConversionRate) / (impressions + SMOOTHING_M);
          }
          return ((s.completions || 0) + SMOOTHING_M * siteCompletionRate) / (impressions + SMOOTHING_M);
        }

        trackEntries.forEach(function (t) {
          var qualified = [];
          var unqualified = [];
          t.entries.forEach(function (entry) {
            var s = stats[entry.v.id];
            var impressions = s ? (s.impressions || 0) : 0;
            if (impressions >= IMPRESSION_GATE) {
              qualified.push(entry);
            } else {
              unqualified.push(entry);
            }
          });
          qualified.sort(function (a, b) { return rateScore(b) - rateScore(a); });
          // Not enough real signal yet -- rank by the same view count the
          // initial render already sorted by, so nothing here moves until a
          // video actually crosses the gate.
          unqualified.sort(function (a, b) { return (b.v.viewCount || 0) - (a.v.viewCount || 0); });
          var sorted = qualified.concat(unqualified);

          var changed = false;
          sorted.forEach(function (entry, i) {
            if (t.entries[i] !== entry) changed = true;
          });
          if (changed) {
            // Detach before reordering -- see the matching comment on the
            // initial build above. A live scroll container can't be raced,
            // only avoided.
            var parent = t.track.parentNode;
            var nextSibling = t.track.nextSibling;
            parent.removeChild(t.track);
            sorted.forEach(function (entry) { t.track.appendChild(entry.el); });
            t.track.scrollLeft = 0;
            if (nextSibling) {
              parent.insertBefore(t.track, nextSibling);
            } else {
              parent.appendChild(t.track);
            }
            t.entries = sorted;
          }
        });
      })
      .catch(function () {});
  }
})();
